






import {Component, Prop, Vue} from 'vue-property-decorator';
import {Inject} from "vue-typedi";
import {TabType} from '@/model/TabType';

@Component
export default class Tab extends Vue {

    @Prop({default: ""}) label: string;
    @Prop({default: 0}) count: number;
    @Prop({default: false}) active: boolean;
    @Prop({default: TabType.TO_PROCESS}) tab: TabType;

    onClick() {
        this.$emit('onClick', this.tab);
    }
}
